// extracted by mini-css-extract-plugin
export default {"weightField":"vehicleForm_weightField__V6upZ","weightUnits":"vehicleForm_weightUnits__9sjcO"};